import SystemInfo from './system-info';

export default SystemInfo;
